class NotificationService {
	constructor($rootScope) {
		this.$rootScope = $rootScope;

		this.init();
	}

	init() {}

	success(msg, timeout = 5000) {
		this.$rootScope.$broadcast('show-notification', msg, undefined, timeout);
	}

	error(msg, err, timeout = 5000) {
		this.$rootScope.$broadcast('show-notification', msg, err || 'FAILED', timeout);
	}

	successModal(msg) {
		this.$rootScope.$broadcast('show-success-modal', msg);
	}

	showModal(success, error) {
		this.$rootScope.$broadcast('show-register-prompt-auth-modal', success, error);
	}

	showForgotPassword() {
		this.$rootScope.$broadcast('show-login-auth-modal');
	}
}

export default /* @ngInject */ ($rootScope) => new NotificationService($rootScope);
